import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { HomePage } from './pages/Home';
import { AboutPage } from './pages/About';
import { MediaPage } from './pages/Media';
import { WritingPage } from './pages/Writing';
import { ArticlePage } from './pages/ArticlePage';
import { VenturesPage } from './pages/Ventures';
import { ContactPage } from './pages/Contact';
export function AppRouter() {
  return <BrowserRouter data-id="element-6">
      <Routes data-id="element-7">
        <Route path="/" element={<App data-id="element-9" />} data-id="element-8">
          <Route index element={<HomePage data-id="element-11" />} data-id="element-10" />
          <Route path="about" element={<AboutPage data-id="element-13" />} data-id="element-12" />
          <Route path="media" element={<MediaPage data-id="element-15" />} data-id="element-14" />
          <Route path="writing" element={<WritingPage data-id="element-17" />} data-id="element-16" />
          <Route path="writing/:slug" element={<ArticlePage data-id="element-19" />} data-id="element-18" />
          <Route path="ventures" element={<VenturesPage data-id="element-21" />} data-id="element-20" />
          <Route path="contact" element={<ContactPage data-id="element-23" />} data-id="element-22" />
        </Route>
      </Routes>
    </BrowserRouter>;
}